// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as VerifyEmailChangeEmailTokenRouteImport } from './routes/verify-email-change.$emailToken'
import { Route as AdminAccessDeniedRouteImport } from './routes/admin/access-denied'
import { Route as AdminProtectedRouteImport } from './routes/admin/_protected'
import { Route as ProtectedWsRouteImport } from './routes/_protected/ws'
import { Route as AuthVerifyRouteImport } from './routes/_auth/verify'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AdminProtectedWorkspacesRouteImport } from './routes/admin/_protected/workspaces'
import { Route as AdminProtectedUsersRouteImport } from './routes/admin/_protected/users'
import { Route as AdminProtectedDashboardRouteImport } from './routes/admin/_protected/dashboard'
import { Route as ProtectedAccountNotificationsRouteImport } from './routes/_protected/_account/notifications'
import { Route as ProtectedAccountBillingRouteImport } from './routes/_protected/_account/billing'
import { Route as ProtectedAccountAccountRouteImport } from './routes/_protected/_account/account'
import { Route as ProtectedWsIndexRouteImport } from './routes/_protected/ws/index'
import { Route as ProtectedWsWorkspaceIdRouteImport } from './routes/_protected/ws/$workspaceId'
import { Route as AdminProtectedWorkspacesIndexRouteImport } from './routes/admin/_protected/workspaces/index'
import { Route as AdminProtectedWorkspacesWorkspaceIdRouteImport } from './routes/admin/_protected/workspaces/$workspaceId'
import { Route as AdminProtectedUsersIndexRouteImport } from './routes/admin/_protected/users/index'
import { Route as AdminProtectedUsersUserIdRouteImport } from './routes/admin/_protected/users/$userId'
import { Route as ProtectedWsWorkspaceIdSettingsRouteImport } from './routes/_protected/ws/$workspaceId/settings'
import { Route as ProtectedWsWorkspaceIdProjectsRouteImport } from './routes/_protected/ws/$workspaceId/projects'
import { Route as ProtectedWsWorkspaceIdOverviewRouteImport } from './routes/_protected/ws/$workspaceId/overview'
import { Route as ProtectedWsWorkspaceIdMembersRouteImport } from './routes/_protected/ws/$workspaceId/members'
import { Route as ProtectedWsWorkspaceIdIntegrationsRouteImport } from './routes/_protected/ws/$workspaceId/integrations'
import { Route as ProtectedWsWorkspaceIdBillingRouteImport } from './routes/_protected/ws/$workspaceId/billing'

const AcceptInviteRoute = AcceptInviteRouteImport.update({
            id: '/accept-invite',path: '/accept-invite',getParentRoute: () => rootRouteImport
          })
const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const VerifyEmailChangeEmailTokenRoute = VerifyEmailChangeEmailTokenRouteImport.update({
            id: '/verify-email-change/$emailToken',path: '/verify-email-change/$emailToken',getParentRoute: () => rootRouteImport
          })
const AdminAccessDeniedRoute = AdminAccessDeniedRouteImport.update({
            id: '/admin/access-denied',path: '/admin/access-denied',getParentRoute: () => rootRouteImport
          })
const AdminProtectedRoute = AdminProtectedRouteImport.update({
            id: '/admin/_protected',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ProtectedWsRoute = ProtectedWsRouteImport.update({
            id: '/ws',path: '/ws',getParentRoute: () => ProtectedRoute
          })
const AuthVerifyRoute = AuthVerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => AuthRoute
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => AuthRoute
          })
const AuthSigninRoute = AuthSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const AdminProtectedWorkspacesRoute = AdminProtectedWorkspacesRouteImport.update({
            id: '/workspaces',path: '/workspaces',getParentRoute: () => AdminProtectedRoute
          })
const AdminProtectedUsersRoute = AdminProtectedUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminProtectedRoute
          })
const AdminProtectedDashboardRoute = AdminProtectedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AdminProtectedRoute
          })
const ProtectedAccountNotificationsRoute = ProtectedAccountNotificationsRouteImport.update({
            id: '/_account/notifications',path: '/notifications',getParentRoute: () => ProtectedRoute
          })
const ProtectedAccountBillingRoute = ProtectedAccountBillingRouteImport.update({
            id: '/_account/billing',path: '/billing',getParentRoute: () => ProtectedRoute
          })
const ProtectedAccountAccountRoute = ProtectedAccountAccountRouteImport.update({
            id: '/_account/account',path: '/account',getParentRoute: () => ProtectedRoute
          })
const ProtectedWsIndexRoute = ProtectedWsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedWsRoute
          })
const ProtectedWsWorkspaceIdRoute = ProtectedWsWorkspaceIdRouteImport.update({
            id: '/$workspaceId',path: '/$workspaceId',getParentRoute: () => ProtectedWsRoute
          })
const AdminProtectedWorkspacesIndexRoute = AdminProtectedWorkspacesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminProtectedWorkspacesRoute
          })
const AdminProtectedWorkspacesWorkspaceIdRoute = AdminProtectedWorkspacesWorkspaceIdRouteImport.update({
            id: '/$workspaceId',path: '/$workspaceId',getParentRoute: () => AdminProtectedWorkspacesRoute
          })
const AdminProtectedUsersIndexRoute = AdminProtectedUsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminProtectedUsersRoute
          })
const AdminProtectedUsersUserIdRoute = AdminProtectedUsersUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => AdminProtectedUsersRoute
          })
const ProtectedWsWorkspaceIdSettingsRoute = ProtectedWsWorkspaceIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ProtectedWsWorkspaceIdRoute
          })
const ProtectedWsWorkspaceIdProjectsRoute = ProtectedWsWorkspaceIdProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => ProtectedWsWorkspaceIdRoute
          })
const ProtectedWsWorkspaceIdOverviewRoute = ProtectedWsWorkspaceIdOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => ProtectedWsWorkspaceIdRoute
          })
const ProtectedWsWorkspaceIdMembersRoute = ProtectedWsWorkspaceIdMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => ProtectedWsWorkspaceIdRoute
          })
const ProtectedWsWorkspaceIdIntegrationsRoute = ProtectedWsWorkspaceIdIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => ProtectedWsWorkspaceIdRoute
          })
const ProtectedWsWorkspaceIdBillingRoute = ProtectedWsWorkspaceIdBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => ProtectedWsWorkspaceIdRoute
          })





const AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSigninRoute: AuthSigninRoute,AuthSignupRoute: AuthSignupRoute,AuthVerifyRoute: AuthVerifyRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const ProtectedWsWorkspaceIdRouteChildren = {
  ProtectedWsWorkspaceIdBillingRoute: ProtectedWsWorkspaceIdBillingRoute,ProtectedWsWorkspaceIdIntegrationsRoute: ProtectedWsWorkspaceIdIntegrationsRoute,ProtectedWsWorkspaceIdMembersRoute: ProtectedWsWorkspaceIdMembersRoute,ProtectedWsWorkspaceIdOverviewRoute: ProtectedWsWorkspaceIdOverviewRoute,ProtectedWsWorkspaceIdProjectsRoute: ProtectedWsWorkspaceIdProjectsRoute,ProtectedWsWorkspaceIdSettingsRoute: ProtectedWsWorkspaceIdSettingsRoute
}

const ProtectedWsWorkspaceIdRouteWithChildren = ProtectedWsWorkspaceIdRoute._addFileChildren(ProtectedWsWorkspaceIdRouteChildren)



const ProtectedWsRouteChildren = {
  ProtectedWsWorkspaceIdRoute: ProtectedWsWorkspaceIdRouteWithChildren,ProtectedWsIndexRoute: ProtectedWsIndexRoute
}

const ProtectedWsRouteWithChildren = ProtectedWsRoute._addFileChildren(ProtectedWsRouteChildren)



const ProtectedRouteChildren = {
  ProtectedWsRoute: ProtectedWsRouteWithChildren,ProtectedAccountAccountRoute: ProtectedAccountAccountRoute,ProtectedAccountBillingRoute: ProtectedAccountBillingRoute,ProtectedAccountNotificationsRoute: ProtectedAccountNotificationsRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)




const AdminProtectedUsersRouteChildren = {
  AdminProtectedUsersUserIdRoute: AdminProtectedUsersUserIdRoute,AdminProtectedUsersIndexRoute: AdminProtectedUsersIndexRoute
}

const AdminProtectedUsersRouteWithChildren = AdminProtectedUsersRoute._addFileChildren(AdminProtectedUsersRouteChildren)




const AdminProtectedWorkspacesRouteChildren = {
  AdminProtectedWorkspacesWorkspaceIdRoute: AdminProtectedWorkspacesWorkspaceIdRoute,AdminProtectedWorkspacesIndexRoute: AdminProtectedWorkspacesIndexRoute
}

const AdminProtectedWorkspacesRouteWithChildren = AdminProtectedWorkspacesRoute._addFileChildren(AdminProtectedWorkspacesRouteChildren)



const AdminProtectedRouteChildren = {
  AdminProtectedDashboardRoute: AdminProtectedDashboardRoute,AdminProtectedUsersRoute: AdminProtectedUsersRouteWithChildren,AdminProtectedWorkspacesRoute: AdminProtectedWorkspacesRouteWithChildren
}

const AdminProtectedRouteWithChildren = AdminProtectedRoute._addFileChildren(AdminProtectedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRouteWithChildren,ProtectedRoute: ProtectedRouteWithChildren,AcceptInviteRoute: AcceptInviteRoute,AdminProtectedRoute: AdminProtectedRouteWithChildren,AdminAccessDeniedRoute: AdminAccessDeniedRoute,VerifyEmailChangeEmailTokenRoute: VerifyEmailChangeEmailTokenRoute,AdminIndexRoute: AdminIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)